import { render } from "./Completing.vue?vue&type=template&id=657e8418&scoped=true"
import script from "./Completing.vue?vue&type=script&lang=js"
export * from "./Completing.vue?vue&type=script&lang=js"

import "@/Common/Styles/buyNft.scss?vue&type=style&index=0&id=657e8418&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657e8418"]])

export default __exports__